import { render, staticRenderFns } from "./createGoods.vue?vue&type=template&id=ff3e16ea&scoped=true&"
import script from "./createGoods.vue?vue&type=script&lang=js&"
export * from "./createGoods.vue?vue&type=script&lang=js&"
import style0 from "./createGoods.vue?vue&type=style&index=0&id=ff3e16ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3e16ea",
  null
  
)

export default component.exports